import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { LuArrowLeft } from "react-icons/lu";
import usePageMeta from "../hooks/usePageMeta";
import { ButtonLink, Container, Eyebrow, Lead } from "../components/ui";

const Wrap = styled.section`
  padding: calc(var(--nav-height) + 120px) 0 140px;
  background: linear-gradient(180deg, var(--color-bg-tint) 0%, var(--color-bg) 100%);

  h1 {
    font-size: clamp(2.25rem, 4.4vw, 3.25rem);
    margin-bottom: 16px;
  }

  a {
    margin-top: 32px;
  }
`;

const NotFound = () => {
  usePageMeta({ title: "Page not found" });

  return (
    <Wrap>
      <Container>
        <Eyebrow>Error 404</Eyebrow>
        <h1>This page doesn't exist</h1>
        <Lead>The link may be broken or the page may have moved.</Lead>
        <ButtonLink as={Link} to="/">
          <LuArrowLeft aria-hidden="true" />
          Back to home
        </ButtonLink>
      </Container>
    </Wrap>
  );
};

export default NotFound;
